import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import { BenefitDetailRenderer } from "./BenefitDetailRenderer";
import type { BenefitDetailData } from "./useBenefitDetailData";

interface CollapsibleBenefitDetailsProps {
  plan: any;
  detailData: BenefitDetailData | undefined;
  annualElection?: number | null;
}

/**
 * Per-election "Benefit Details" disclosure for the summary review. Closed by
 * default so the summary stays scannable; the underlying queries are already
 * prefetched by useBenefitDetailData so expanding is instant.
 */
export function CollapsibleBenefitDetails({
  plan,
  detailData,
  annualElection,
}: CollapsibleBenefitDetailsProps) {
  const [open, setOpen] = useState(false);

  return (
    <Collapsible open={open} onOpenChange={setOpen} className="mt-4 pt-3 border-t">
      <CollapsibleTrigger className="flex items-center gap-1.5 text-xs font-medium uppercase tracking-wide text-gray-500 hover:text-gray-700 dark:hover:text-gray-300 transition-colors">
        <ChevronDown
          className={cn("h-3.5 w-3.5 transition-transform", open && "rotate-180")}
        />
        {open ? "Hide benefit details" : "View benefit details"}
      </CollapsibleTrigger>
      <CollapsibleContent className="mt-3">
        <BenefitDetailRenderer
          plan={plan}
          detailData={detailData}
          annualElection={annualElection}
        />
      </CollapsibleContent>
    </Collapsible>
  );
}
